// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".NavTopBarContextMenu-base__Po9XV{display:flex;flex-shrink:0;align-items:center;margin-left:calc(var(--size-2) - var(--nav-top-bar-header-start-gap))}.NavTopBarContextMenu-base__Po9XV:first-child{margin-left:var(--size-0)}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"base": "NavTopBarContextMenu-base__Po9XV"
};
export default ___CSS_LOADER_EXPORT___;
